// extracted by mini-css-extract-plugin
module.exports = {"input-range":"InputRange_input-range__FQpna","input-range__heading":"InputRange_input-range__heading__3995N","input-range__field":"InputRange_input-range__field__3be2K"};